import { z } from 'zod';

type RegexOptions = Parameters<z.ZodString['regex']>[1];

const prefix = (options?: RegexOptions) => z.string().regex(/^[a-z0-9]+$/, options);

const prefixedKey = (options?: RegexOptions) => z.string().regex(/^[a-z0-9]+_[0-9a-f]{0,32}$/, options);

const prefixedByKey = (prefix: string, options?: RegexOptions) =>
  z.string().regex(RegExp(`^${prefix}_[0-9a-f]{0,32}$`), options);

export const zKey = {
  prefix: prefix,
  prefixedKey: prefixedKey,
  prefixedByKey: prefixedByKey,
};
